import { render, staticRenderFns } from "./store-search-classify.vue?vue&type=template&id=1566c65c&scoped=true"
import script from "./store-search-classify.vue?vue&type=script&lang=js"
export * from "./store-search-classify.vue?vue&type=script&lang=js"
import style0 from "./store-search-classify.vue?vue&type=style&index=0&id=1566c65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566c65c",
  null
  
)

export default component.exports